<template>
  <div class="terms-page" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="terms-header">
        <h1>{{ $t('termsAndConditions') }}</h1>
      </div>
      
      <div class="terms-content">
        <!-- English Terms -->
        <div v-if="$i18n.locale === 'en'" class="terms-text">
          <p class="terms-intro">
            PLEASE READ THIS AGREEMENT CAREFULLY. IT STATES THE LEGALLY BINDING TERMS AND
            CONDITIONS FOR YOUR USE OF THE SERVICE OFFERED BY FenTec Mobility.
          </p>
          
          <div class="company-info">
            <h2>Company information</h2>
            <p>Company: FenTec Mobility</p>
            <p>Address: 29 rue "P", City of Riyadh, Batna 05010, Algeria.</p>
            <p>Commercial Register Number: 24A6114552</p>
            <p>Tax identification number (NIF): 1950501067800500</p>
            <p>Statistical Identification Number (NIS): 1 995 0501 06700 39</p>
            <p>Email: Contact@fentecmobility.com</p>
            <p>Customer service: +213 540842707</p>
          </div>
          
          <p>
            By using our Services (including in particular our User Applications, payment, store and our website), our
            vehicles (Electric Scooters) including accessories (helmet and safety cable).
          </p>
          
          <p>
            You have agreed to comply with these Terms of Service as a condition of using our Services.
            We may modify these Terms of Use at any time and the revised version will be effective when we post it
            on the Website and we will inform you via our social networks.
          </p>
          
          <p>
            The revised Terms of Use will supersede all prior versions.
            These Terms of Use also expressly supersede any prior agreements or arrangements we may have
            entered into with you.
          </p>
          
          <h3>1. What FenTec Mobility offers</h3>
          <p>
            FenTec Mobility was founded to transform transportation in cities into a shared, fun, safe, sustainable,
            eco-friendly and affordable way. Our Services help make this idea a reality. We are continually evolving
            our Services, and as of the above date, they include a user application, a payment application, a
            Dashboard, a website, electric scooters equip with helmets and safety cables.
          </p>
          <p>
            The user app will allow you to rent our electric scooters by the minute and the rates are displayed on
            the rental page, if this is not clear please contact support@fentecmobility.com
          </p>
          <p>
            To recharge your e-wallet please visit one of our FenPay points (location available on the home page of
            the user application, our website and on our social media platforms) if you encounter difficulties please
            contact support@fenetcmobility.com
          </p>
          
          <h3>2. Your FenTec Mobility user account</h3>
          <p>
            Account Setup. In order to use most aspects of the Services, you must register and maintain an active
            personal user account, which requires a national card or driver's license, as well as other information
            requested depending on the Product.
          </p>
          <p>
            Providing this information is necessary to enable us to provide you with the Services.
            Other account creation and payment methods are available for some of our Products and Services if
            offered in your region, such as FenPay.
          </p>
          
          <h3>3. Use of the application and our Services</h3>
          <p>
            You may use the Application and our Services after setting up your account as described in Section 2
            above.
          </p>
          <p>
            You may use the Application to locate and rent our available Products. The price of the Products you
            rent will be displayed in the Application before you begin your journey some essential rules.
          </p>
          
          <h3>4. Use our Products safely!</h3>
          <p>
            We want you and those around you to be safe and that means following certain rules.
            Please read our safety recommendations for users:
          </p>
          <p>
            Please note that you are the only person responsible for the scooter that you have unlocked and any
            damage will be charged to you in order to repair it. The costs will be determined after analysis of the
            scooter with a maximum of 300,000.00DA.
          </p>
          
          <h3>5. Financial conditions</h3>
          <p>
            5.1- Pricing and payment.
            You may rent our Services on a per-ride basis or as part of a subscription (where subscriptions are
            offered). All rates are set out in the Application.
          </p>
          
          <h3>12. Applicable law and disputes</h3>
          <p>
            These Terms of Use are governed by Algerian's law, If you have had an accident while using our Services,
            you must notify us within 20 minutes of the accident, to report an accident.
          </p>
          <p>
            If you have any question, don't hesitate to contact us on contact@fentecmobility.com.
          </p>
          
          <div class="social-links">
            <h3>Our social media links:</h3>
            <p>
              Instagram: <a href="https://www.instagram.com/fentec_mobility/?igsh=MTN5MXlndHVoODd3cg%3D%3D" target="_blank">https://www.instagram.com/fentec_mobility</a>
            </p>
            <p>
              Facebook: <a href="https://www.facebook.com/profile.php?id=61564285140098&mibextid=ZbWKwL" target="_blank">https://www.facebook.com/profile.php?id=61564285140098</a>
            </p>
            <p>
              TikTok: <a href="https://www.tiktok.com/@fentec.mobility?_t=8p4B2G0PBdy&_r=1" target="_blank">https://www.tiktok.com/@fentec.mobility</a>
            </p>
          </div>
        </div>
        
        <!-- Arabic Terms -->
        <div v-if="$i18n.locale === 'ar'" class="terms-text">
          <p class="terms-intro">
            يرجى قراءة هذه الاتفاقية بعناية. تنص على الشروط الملزمة قانونا
            لاستخدامك للخدمة التي تقدمها FenTec Mobility.
          </p>
          
          <div class="company-info">
            <h2>معلومات الشركة</h2>
            <p>شركة: FenTec Mobility</p>
            <p>العنوان: 29 شارع "P"، مدينة الرياض، باتنة 05010، الجزائر.</p>
            <p>رقم السجل التجاري: 24A6114552</p>
            <p>رقم التعريف الضريبي (NIF): 1950501067800500</p>
            <p>رقم التعريف الإحصائي (NIS): 1 995 0501 06700 39</p>
            <p>البريد الإلكتروني: Contact@fentecmobility.com</p>
            <p>خدمة العملاء: +213 540842707</p>
          </div>
          
          <p>
            باستخدامك لخدماتنا (بما في ذلك على وجه الخصوص تطبيقات المستخدم والدفع والمتجر وموقعنا الإلكتروني)، ومركباتنا (الدراجات البخارية الكهربائية) بما في ذلك الملحقات (الخوذة وكابل الأمان).
          </p>
          
          <p>
            لقد وافقت على الامتثال لشروط الخدمة هذه كشرط لاستخدام خدماتنا.
            يجوز لنا تعديل شروط الاستخدام هذه في أي وقت وستكون النسخة المنقحة سارية المفعول عندما ننشرها على الموقع الإلكتروني وسنبلغك عبر شبكات التواصل الاجتماعي الخاصة بنا.
          </p>
          
          <p>
            ستحل شروط الاستخدام المعدلة محل جميع الإصدارات السابقة.
            كما تحل شروط الاستخدام هذه صراحة محل أي اتفاقيات أو ترتيبات سابقة قد نكون أبرمناها معك.
          </p>
          
          <h3>1. ما تقدمه FenTec Mobility</h3>
          <p>
            تأسست FenTec Mobility لتحويل النقل في المدن إلى طريقة مشتركة وممتعة وآمنة ومستدامة وصديقة للبيئة وبأسعار معقولة. تساعد خدماتنا في جعل هذه الفكرة حقيقة واقعة. نحن نعمل باستمرار على تطوير خدماتنا، واعتبارا من التاريخ أعلاه، فهي تشمل تطبيق مستخدم، وتطبيق دفع، ولوحة تحكم، وموقع ويب، ودراجات بخارية كهربائية مجهزة بخوذات وكابلات أمان.
          </p>
          <p>
            سيسمح لك تطبيق المستخدم باستئجار دراجاتنا البخارية الكهربائية بالدقيقة ويتم عرض الأسعار في صفحة التأجير، إذا لم يكن ذلك واضحا فيرجى الاتصال support@fentecmobility.com
          </p>
          <p>
            لإعادة شحن محفظتك الإلكترونية يرجى زيارة إحدى نقاط FenPay الخاصة بنا (الموقع متاح على الصفحة الرئيسية لتطبيق المستخدم وموقعنا الإلكتروني وعلى منصات التواصل الاجتماعي الخاصة بنا) إذا واجهت صعوبات يرجى الاتصال pleasecontactsupport@fenetcmobility.com
          </p>
          
          <h3>2. حساب FenTec Mobility الخاص بك</h3>
          <p>
            إعداد الحساب. من أجل استخدام معظم جوانب الخدمات، يجب عليك تسجيل حساب مستخدم شخصي نشط والاحتفاظ به، والذي يتطلب بطاقة وطنية أو رخصة قيادة، بالإضافة إلى معلومات أخرى مطلوبة اعتمادا على المنتج.
          </p>
          <p>
            يعد تقديم هذه المعلومات ضروريا لتمكيننا من تزويدك بالخدمات.
            تتوفر طرق أخرى لإنشاء الحساب والدفع لبعض منتجاتنا وخدماتنا إذا تم تقديمها في منطقتك، مثل FenPay.
          </p>
          
          <h3>3. استخدام التطبيق وخدماتنا</h3>
          <p>
            يمكنك استخدام التطبيق وخدماتنا بعد إعداد حسابك كما هو موضح في القسم 2 أعلاه.
          </p>
          <p>
            يمكنك استخدام التطبيق لتحديد موقع منتجاتنا المتاحة واستئجارها. سيتم عرض سعر المنتجات التي تستأجرها في التطبيق قبل أن تبدأ رحلتك وبعض القواعد الأساسية.
          </p>
          
          <h3>4. استخدام منتجاتنا بأمان!</h3>
          <p>
            نريدك ومن حولك أن تكونوا آمنين وهذا يعني اتباع قواعد معينة.
            يرجى قراءة توصيات السلامة الخاصة بنا للمستخدمين:
          </p>
          <p>
            يرجى ملاحظة أنك الشخص الوحيد المسؤول عن السكوتر الذي قمت بفتحه وأي ضرر سيتم فرضه عليك من أجل إصلاحه. سيتم تحديد التكاليف بعد تحليل للسكوتر بحد أقصى 300,000.00DA.
          </p>
          
          <h3>5. الشروط المالية</h3>
          <p>
            5.1- التسعير والدفع.
            يمكنك استئجار خدماتنا على أساس كل رحلة أو كجزء من اشتراك (حيث يتم تقديم الاشتراكات). جميع الأسعار محددة في التطبيق.
          </p>
          
          <h3>12. القانون الواجب التطبيق والنزاعات</h3>
          <p>
            تخضع شروط الاستخدام هذه للقانون الجزائري، إذا تعرضت لحادث أثناء استخدام خدماتنا، فيجب عليك إخطارنا في غضون 20 دقيقة من وقوع الحادث، للإبلاغ عن حادث.
          </p>
          <p>
            إذا كان لديك أي سؤال، فلا تتردد في الاتصال بنا على contact@fentecmobility.com.
          </p>
          
          <div class="social-links">
            <h3>روابط وسائل التواصل الاجتماعي الخاصة بنا:</h3>
            <p>
              إنستغرام: <a href="https://www.instagram.com/fentec_mobility/?igsh=MTN5MXlndHVoODd3cg%3D%3D" target="_blank">https://www.instagram.com/fentec_mobility</a>
            </p>
            <p>
              فيسبوك: <a href="https://www.facebook.com/profile.php?id=61564285140098&mibextid=ZbWKwL" target="_blank">https://www.facebook.com/profile.php?id=61564285140098</a>
            </p>
            <p>
              تيك توك: <a href="https://www.tiktok.com/@fentec.mobility?_t=8p4B2G0PBdy&_r=1" target="_blank">https://www.tiktok.com/@fentec.mobility</a>
            </p>
          </div>
        </div>
      </div>
    </div>
      <footer>
      <div class="content">
        <p style="color: #ffe5cf;margin-bottom: -10px;" class="mobile-footer-paragraoh" v-html="$t('footer.content')"></p>

        <div>
            
            <a href="/terms-And-Conditions">
                {{ $t('termsAndConditions')}}<br>
            </a>
            <a href="">
                {{ $t('serviceAgreement')}}<br>
            </a>
            <a href="/Privacy-Police">
              {{ $t('privacyPolicy')}}
            </a>
        </div>
        <div class="links">
          <!-- <a href="">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-youtube" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z" />
              <path d="M10 9l5 3l-5 3z" />
            </svg>
          </a> -->
          <a href="https://www.facebook.com/profile.php?id=61564285140098&mibextid=qi2Omg&rdid=VoFkZZFPPZnTyg15&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FJhifFbsE52pYV6mz%2F%3Fmibextid%3Dqi2Omg" target="_blanck">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-facebook" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
            </svg>
          </a>
          <a href="https://www.instagram.com/fentec_mobility?igsh=MTN5MXlndHVoODd3cg%3D%3D" target="_blanck">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-instagram" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" />
              <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
              <path d="M16.5 7.5l0 .01" />
            </svg>
          </a>
          <!-- <a href="">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-whatsapp" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
              <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
            </svg>
          </a> -->
          <a href="https://www.tiktok.com/@fentec.mobility?_t=8p4B2G0PBdy&_r=1" target="_blanck">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-tiktok" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z" />
            </svg>
          </a>
        </div>
        <div class="btns">
          <a href=""><img src="/imgs/app.png?v=1.0" alt="App store"></a>
          <a href="http://fentecmobility.com/fentec.apk" download ><img src="/imgs/play_store.png?v=1.0" alt="Play store"></a>
        </div>
      </div>
      <div class="img">
        <img src="/imgs/footer-img.png?v=1.0" alt="">
        <p v-html="$t('footer.content')"></p>
      </div>
  </footer>

  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  methods: {
    changeLanguage(locale) {
      this.$i18n.locale = locale;
      document.documentElement.lang = locale;
      document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
    }
  }
}
</script>

<style scoped>
.terms-page {
  min-height: 100vh;
  margin-top: 100px;
  background-color: #f9f9f9;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.terms-header {
  text-align: center;
  margin-bottom: 30px;
}

.terms-header h1 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 10px;
}

.language-selector {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  gap: 10px;
}

.language-selector button {
  padding: 8px 20px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
}

.language-selector button.active {
  background-color: #FF6B00;
  color: white;
  border-color: #FF6B00;
}

.terms-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-bottom: 40px;
}

.terms-text {
  line-height: 1.6;
}

.terms-intro {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 20px;
  color: #333;
}

.company-info {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 6px;
  margin: 20px 0;
}

.company-info h2 {
  margin-top: 0;
  color: #FF6B00;
}

.terms-text h3 {
  color: #FF6B00;
  margin-top: 30px;
  margin-bottom: 15px;
  font-size: 1.3rem;
}

.terms-text p {
  margin-bottom: 15px;
}

.social-links {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.social-links a {
  color: #FF6B00;
  text-decoration: none;
}

.social-links a:hover {
  text-decoration: underline;
}


</style>